import { useContext, useMemo } from 'react';
import identity from 'transmute/identity';
import FormattedMessage from 'I18n/components/FormattedMessage';
import KnowledgePopoverEmptyState from './draft-content-transplant-ka/KnowledgePopoverEmptyState';
import KnowledgePopoverErrorState from './draft-content-transplant-ka/KnowledgePopoverErrorState';
import transformArticlesData from './draft-content-transplant-ka/transformArticlesData';
import GenericPopoverHeader from '../../components/GenericPopoverHeader';
import { ContentContainerV2 } from '../../components/insertMenu/ContentContainer';
import InsertContentDecorator from '../../../draft-transplant/InsertContentDecoratorV2';
import contentOutputs from '../../editorCapabilities/ContentOutputTypes';
import { EditorConfigContext } from '../../contexts/EditorConfigContext';
import { getKnowledgeUrl } from '../../utils/manageLinks';
import { jsx as _jsx } from "react/jsx-runtime";
const KBArticlesTypeahead = ({
  apiFunctions,
  knowledgeBaseId,
  onChange,
  onClickBack,
  portalId,
  title
}) => {
  const {
    KNOWLEDGE_ARTICLE: {
      onClickManage = undefined,
      onInsertContent = identity,
      onSearchKB = undefined,
      outputType = contentOutputs.RENDERED
    } = {}
  } = useContext(EditorConfigContext);

  // Hosts rebuild these callbacks with their config, so they're passed as props
  // below; baking them into this component would remount the open list.
  const LocalKBArticlesTypeahead = useMemo(() => {
    const insertKnowledgeArticlesDecoratorConfig = {
      outputType,
      apiFunctions,
      mergeTagOptions: {
        includeCustomTokens: true
      }
    };
    return InsertContentDecorator(ContentContainerV2({
      portalId,
      PopoverErrorState: KnowledgePopoverErrorState,
      PopoverEmptyState: KnowledgePopoverEmptyState,
      searchPlaceHolder: 'hubspot-prosemirror.knowledgeBase.search.placeholder',
      transformData: transformArticlesData,
      search: apiFunctions.searchArticles,
      contentKey: 'kbArticles'
    }), insertKnowledgeArticlesDecoratorConfig);
  }, [apiFunctions, outputType, portalId]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react-hooks/static-components
    _jsx(LocalKBArticlesTypeahead, {
      onChange: onChange,
      useProsemirror: true,
      onInsertContent: onInsertContent,
      onSearchChange: onSearchKB,
      Header: /*#__PURE__*/_jsx(GenericPopoverHeader, {
        manageUrl: getKnowledgeUrl(portalId, knowledgeBaseId),
        onClickManageButton: onClickManage,
        onViewInsertMenu: onClickBack,
        portalId: portalId,
        titleMessage: title || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.insertMenu.knowledgeArticle"
        })
      })
    })
  );
};
export default KBArticlesTypeahead;